export const convertMimeToExtension = (mime) => {
    const mimeMapper = {
        'image/jpg': '.jpg',
        'image/jpeg': '.jpeg',
        'image/png': '.png',
        'application/msword': '.doc',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
        'application/xml': '.xml',
        'text/xml': '.xml',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
        'text/csv': '.csv',
        'application/vnd.google-apps.document': '.gdoc',
        'application/vnd.google-apps.kix': '.gdoc',
        'application/vnd.google-apps.presentation': '.gsheet',
        'application/pdf': '.pdf'
    };

    return mimeMapper?.[mime];
}

const allowedTypes = [
    'image/jpg',
    'image/jpeg',
    'image/png',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/xml',
    'text/xml',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/csv',
    'application/vnd.google-apps.document',
    'application/vnd.google-apps.kix',
    'application/vnd.google-apps.presentation',
    'application/pdf'
];

const allowedExtensions = [
    '.jpg',
    '.jpeg',
    '.png',
    '.doc',
    '.docx',
    '.xml',
    '.xlsx',
    '.csv',
    '.gdoc',
    '.gsheet',
    '.pdf'
];
export const getAllowedFileTypes = [...allowedTypes, ...allowedExtensions];

export const fileTypesWithoutPreview = [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/xml',
    'text/xml',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/csv'
];

export const fileTypesAsImage = [
    'image/jpg',
    'image/jpeg',
    'image/png'
]

export const validateFiles = (files) => {
    if (files.length > 10) {
        alert('Je kan maximaal 10 bestanden tegelijk uploaden');
        
        return false;
    }

    const maxSize = 1024 * 1024 * 20;
    let error = false;
    for (const file of files) {
        if (error) continue;
        if (!allowedTypes.includes(file.type)) {
            alert(`Het bestandstype van ${file.name} wordt niet ondersteund. De toegestane bestandtypes zijn: ${allowedExtensions.join(', ')}`);
            error = true;
        }
        if (file.size > maxSize) {
            alert('Bestanden mogen niet groter zijn dan 10mb per bestand');
            error = true;
        }
    }

    if (error) return false;

    return true;
}